import StatisticCard from "./StatisticCard";
import { getLang } from "../../../store/uiStore";
import SectionCard from "../components/common/SectionCard";

export default function ImplementationSection({ data }) {
    const lang = getLang();
    const tr = {
        section: lang === "ru" ? "Процесс внедрения" : "Раванди татбиқ",
        registered: lang === "ru" ? "Зарегистрировано" : "Сабтиншуда",
        passport: lang === "ru" ? "Предоставили паспорт" : "Шиноснома пешниҳод карданд",
        legal: lang === "ru" ? "Юридические лица" : "Шахсони ҳуқуқӣ",
        individual: lang === "ru" ? "Физические лица" : "Шахсони воқеӣ",
    };

    if (!data) {
        return null;
    }

    return (

        <SectionCard

            title={tr.section}

            icon="hospital"

        >
            <div className="row g-3">

                <div className="col-lg-3 col-md-6">

                    <StatisticCard
                        title={tr.registered}
                        value={data.registered.count}
                        subtitle={`${data.registered.percent}%`}
                    />

                </div>

                <div className="col-lg-3 col-md-6">

                    <StatisticCard
                        title={tr.passport}
                        value={data.passport.count}
                        subtitle={`${data.passport.percent}%`}
                    />

                </div>

                <div className="col-lg-3 col-md-6">

                    <StatisticCard
                        title={tr.legal}
                        value={data.legal_types.legal.count}
                        subtitle={`${data.legal_types.legal.percent}%`}
                    />

                </div>

                <div className="col-lg-3 col-md-6">

                    <StatisticCard
                        title={tr.individual}
                        value={data.legal_types.individual.count}
                        subtitle={`${data.legal_types.individual.percent}%`}
                    />

                </div>

            </div>

        </SectionCard>

    );

}
